"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchVenuesRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class SearchVenuesRequestDto {
  constructor() {
    this.pageIndex = 0;
  }
}
exports.SearchVenuesRequestDto = SearchVenuesRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SearchVenuesRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], SearchVenuesRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", String)], SearchVenuesRequestDto.prototype, "terms", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  default: 0
}), __metadata("design:type", Number)], SearchVenuesRequestDto.prototype, "pageIndex", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  enum: enums_1.MapVersion,
  description: 'Map mode/version. Legacy returns all matches. New returns venues only when they have at least one activity stat or a custom logoUrl (non-null `logo_url` in DB).'
}), __metadata("design:type", String)], SearchVenuesRequestDto.prototype, "mapMode", void 0);
//# sourceMappingURL=SearchVenuesRequest.dto.js.map